import { gql } from "apollo-boost";

export const GET_PROGRAM = gql`
query allProgram($programId: Int,$clubId: Int ) {
  allProgram(programId: $programId,clubId: $clubId) {
    edges {
      node {
        id
        programId
        programName
        programShortDesc
        programDesc
        programType
        focus
        goals
        duration
        structure        
        parentProgramId
        startDate
        endDate
        club {
          clubId
          clubName
        }
        private
        workouts {
          edges {
            node {
              id
              workoutId
              workoutDesc
              duration
              volume
              dayOfMicrocycle
              videoUrl
              programId
              sets {
                edges {
                  node {
                    setId
                    setName
                    setDesc
                    setPurpose
                    noOfSets
                    noOfRep
                    distance
                    distanceSum
                    stroke
                    tag
                    workoutId
                    setInterval
                    timePerDist
                    timeTotal
                    equipment                    
                    isLibrarySet
                    order            
                    videoUrl        
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const GET_WORKOUT_SCHEDULES = gql`
query allWorkoutSchedules($groupId: Int, $dayOfWeek: String) {
  allWorkoutSchedules(groupId: $groupId, dayOfWeek: $dayOfWeek) {
    edges {
      node {
        seqNo
        groupId
        termId
        dayOfWeek
        startTime
        endTime
        workoutType
        facilityId
        notes
      }
    }
  }
}

`;